import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import PersonIcon from "@mui/icons-material/Person";

function WaitForOthersDialog({ open, signers = [] }) {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        style: {
          backgroundColor: "white",
          borderRadius: 16,
          padding: "16px",
          zIndex: 20000, // Ensure modal appears above text fields (10000+)
        },
      }}
      BackdropProps={{
        style: { 
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 19999, // Backdrop should be just below modal
        },
      }}
      sx={{
        zIndex: 20000, // Ensure Dialog container is above text fields
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          padding: "24px 24px 16px",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: "#1a237e",
            fontWeight: 600,
            fontSize: "1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <PersonIcon sx={{ color: "#1976d2" }} />
          Signatures Pending
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ padding: "0 24px 24px" }}>
        <Typography
          variant="body1"
          sx={{
            color: "#d32f2f",
            textAlign: "center",
            mb: 3,
            fontWeight: 500,
            lineHeight: 1.5,
          }}
        >
          This document requires other signatures first. You'll be notified when
          it's your turn.
        </Typography>

        <List sx={{ width: "100%" }}>
          {signers.map((signer, index) => (
            <ListItem
              key={index}
              sx={{
                py: 0.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                {signer.completed_status ? (
                  <CheckCircleIcon sx={{ color: "#28a745", fontSize: 20 }} />
                ) : (
                  <RadioButtonUncheckedIcon
                    sx={{ color: "#6c757d", fontSize: 20 }}
                  />
                )}
              </ListItemIcon>
              <ListItemText
                primary={signer.email}
                sx={{
                  "& .MuiListItemText-primary": {
                    color: "rgba(0, 0, 0, 0.87)",
                    fontSize: "0.95rem",
                  },
                }}
              />
            </ListItem>
          ))}
        </List>

        {/* <Box
          sx={{
            mt: 2,
            p: 2,
            bgcolor: "rgba(25, 118, 210, 0.08)",
            borderRadius: 1,
            border: "1px solid rgba(25, 118, 210, 0.2)",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "rgba(0, 0, 0, 0.6)",
              textAlign: "center",
              lineHeight: 1.5,
            }}
          >
            You will receive an email notification when it's your turn to sign.
          </Typography>
        </Box> */}
      </DialogContent>
    </Dialog>
  );
}

export default WaitForOthersDialog;
